import { z } from 'zod';
import { ArticleReactionKind } from './reaction.js';
/** Body for `POST /articles/:slug/reactions` — set or change the
 *  viewer's reaction. The slug lives on the path; the body carries
 *  only the picked kind. */
export const SetReactionRequest = z.object({
    kind: ArticleReactionKind,
});
//# sourceMappingURL=requests.js.map